<template>
  <v-card outlined rounded="lg">
    <v-btn text color="primary" class="float-right mt-2 mr-2" small @click="onEditClick">
      <v-icon small left>mdi-pencil</v-icon>
      Editar
    </v-btn>
    <div class="d-flex gap-4 align-center pa-3">
      <div>
        <v-img
          :src="bank.logo"
          contain
          height="90"
          width="90"
          class="rounded-lg"
        ></v-img>
      </div>

      <div class="flex-grow-1 d-flex justify-space-between align-center">
        <div>
          <p class="mb-0 text-overline lh-1">{{ bank.code }}</p>
          <h4 class="mb-0">{{ bank.name }}</h4>
          <p class="mb-0 text-caption">
            {{ binsCount }} BIN{{ binsCount !== 1 ? "s" : "" }} cadastrado{{
              binsCount !== 1 ? "s" : ""
            }}
          </p>
        </div>
      </div>
      <v-spacer />
    </div>

   
  </v-card>
</template>

<script>

export default {
  name: "BankCard",
  props: {
    bank: {
      type: Object,
      required: true,
    },
  },
  computed: {
    binsCount() {
      return Array.isArray(this.bank.bins)
        ? this.bank.bins.length
        : JSON.parse(this.bank.bins || '[]').length;
    },
  },
  methods: {
    onEditClick() {
      this.$emit("edit-bank", this.bank);
    },
  },
};
</script>
